function filterIngredients(ingredientTuples, filterValue) {
  ingredientTuples.forEach(([ingredient, tags]) => {
    if (!filterValue) ingredient.classList.remove("eza-hidden");
    else
      ingredient.classList[tags.includes(filterValue) ? "remove" : "add"](
        "eza-hidden",
      );
  });
}

function initIngredients(el) {
  const ingredients = el.querySelectorAll(".eza-ingredients-list-item");
  if (!ingredients.length) return;

  const ingredientTuples = Array.from(ingredients).map((ingredient) => {
    const tags = JSON.parse(ingredient.dataset.tags || "");
    return [ingredient, tags];
  });

  const filterButtons = el.querySelectorAll(".eza-ingredients-filter-item");
  filterButtons.forEach((filterButton) => {
    filterButton.addEventListener("mouseup", () => {
      filterButton.classList.remove("eza-inactive");

      const siblings = Array.from(filterButton.parentNode.children).filter(
        (el) => el !== filterButton,
      );
      siblings.forEach((sibling) => {
        sibling.classList.add("eza-inactive");
      });

      const filterValue = filterButton.dataset.filterValue || "";
      filterIngredients(ingredientTuples, filterValue);
    });
  });
}

function initAllIngredients() {
  const els = document.querySelectorAll(".eza-ingredients");
  els.forEach(initIngredients);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllIngredients);
} else {
  initAllIngredients();
}
